import Decimal from "decimal.js";
import type { MyBet } from "@crashx/shared";
import { moneyInput } from "./betSettings.js";

export interface AutoSettings {
  rounds: number;
  stopWin: string;
  stopLoss: string;
}
export type AutoStop = "completed" | "winLimit" | "lossLimit" | "stopped" | "disconnected" | "rejected";
export class AutoBetSession {
  remaining: number;
  reason: AutoStop | null = null;
  private net = new Decimal(0);
  private round: string | null = null;
  private betId: string | null = null;
  private awaiting = false;
  constructor(private settings: AutoSettings) {
    if (
      !Number.isInteger(settings.rounds) ||
      settings.rounds < 1 ||
      settings.rounds > 1000 ||
      [settings.stopWin, settings.stopLoss].some((value) => value !== "" && !moneyInput(value)?.gt(0))
    )
      throw new Error("Invalid auto settings");
    this.remaining = settings.rounds;
  }
  get total(): number {
    return this.settings.rounds;
  }
  get currentRound(): number {
    return Math.max(1, this.total - this.remaining);
  }
  get netResult(): string {
    return this.net.toString();
  }
  claim(roundId: string): boolean {
    if (this.reason || this.awaiting || this.betId || this.round === roundId || this.remaining <= 0)
      return false;
    this.round = roundId;
    this.awaiting = true;
    return true;
  }
  accept(betId: string): void {
    this.awaiting = false;
    this.betId = betId;
    this.remaining--;
  }
  settle(bet: MyBet): boolean {
    if (bet.betId !== this.betId || !["won", "lost", "cancelled"].includes(bet.status)) return false;
    this.betId = null;
    if (bet.status !== "cancelled") this.net = this.net.plus(bet.win ?? 0).minus(bet.amount);
    if (!this.reason) {
      if (this.settings.stopWin && this.net.gte(this.settings.stopWin)) this.reason = "winLimit";
      else if (this.settings.stopLoss && this.net.lte(new Decimal(this.settings.stopLoss).negated()))
        this.reason = "lossLimit";
      else if (!this.remaining) this.reason = "completed";
    }
    return true;
  }
  stop(reason: AutoStop): void {
    this.reason = reason;
  }
}
